import React, { useState } from "react";
import { Box, Typography, Card, CardHeader, CardContent, IconButton, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import MeterSelectionBox from "./MeterSelectionBox";

const MeterStep = ({
    buildings,
    setMetersForBuilding, // <-- Use this prop for updating meters per building
}) => {
    // Track which building panels are expanded
    const [expanded, setExpanded] = useState(buildings.map(() => true));

    // Toggle expand/collapse for a building
    const handleToggleExpand = (idx) => {
        setExpanded(expanded.map((val, i) => (i === idx ? !val : val)));
    };

    if (!buildings || !buildings[0]?.building?.postalCode || !buildings[0]?.building?.streetNumber) {
        return (
            <Box sx={{ mt: 2 }}>
                <Typography color="error" variant="h6" sx={{ mb: 2 }}>
                    No buildings found. Please check the building information entered in the Building Step.
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Select Meters for Each Building</Typography>
            {buildings.map((b, idx) => (
                <Card key={idx} sx={{ mb: 2 }}>
                    <CardHeader
                        title={
                            <Typography variant="subtitle1">
                                Building {idx + 1}: {b.building.name || <span style={{ color: "#aaa" }}>Unnamed</span>}
                            </Typography>
                        }
                        action={
                            <IconButton onClick={() => handleToggleExpand(idx)} size="small">
                                {expanded[idx] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        }
                    />
                    <Collapse in={expanded[idx]}>
                        <CardContent>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                {b.building.postalCode} {b.building.streetNumber}
                                {b.building.addition ? ` ${b.building.addition}` : ""}
                            </Typography>
                            <MeterSelectionBox
                                onMetersChange={(meters) => setMetersForBuilding(idx, meters)}
                                postalCode={b.building.postalCode}
                                streetNumber={b.building.streetNumber}
                                streetNumberAddition={b.building.addition}
                            />
                        </CardContent>
                    </Collapse>
                </Card>
            ))}
        </Box>
    );
};

export default MeterStep;